(function () {
  function fixInitialPrice() {
    const priceWrap = document.querySelector(".sf-price");
    if (!priceWrap) return;

    const priceEl = priceWrap.querySelector(".sf-price__regular");
    const compareEl = priceWrap.querySelector(".sf-price__sale");

    if (!priceEl || !compareEl) return;

    const price = priceWrap.dataset.price;
    const compare = priceWrap.dataset.comparePrice;

    if (compare && Number(compare) > Number(price)) {
      compareEl.textContent = Shopify.formatMoney(compare);
      compareEl.style.display = "inline";
    }
  }

  // Run after everything loads
  window.addEventListener("load", function () {
    setTimeout(fixInitialPrice, 300);
  });
})();
